import type { TiltifyDonation } from "@playlive/tiltify-lib";
import { useMutation } from "@tanstack/react-query";
import useTiltifyConfig from "./useTiltifyConfig";

async function postTestDonations(
  donations: TiltifyDonation | TiltifyDonation[],
  accessToken: string,
): Promise<void> {
  const endpoint = `${import.meta.env.VITE_ALERT_SERVICE_URI}/donations/tiltify/test`;
  const response = await fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `OAuth ${accessToken}`,
    },
    body: JSON.stringify(donations),
  });
  if (!response.ok) {
    throw new Error(`Failed to send test donation(s): ${response.status} ${response.statusText}`);
  }
}

export default function useTiltifyTestDonations() {
  const accessToken = useTiltifyConfig().tiltifyAccessToken;

  const { mutate, mutateAsync, isPending, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (donations: TiltifyDonation | TiltifyDonation[]) => {
      if (!accessToken) {
        throw new Error("Not authenticated with Tiltify.");
      }
      return postTestDonations(donations, accessToken);
    },
  });

  return {
    sendTestDonation: mutate,
    sendTestDonationAsync: mutateAsync,
    isPending,
    isError,
    isSuccess,
    error,
    reset,
  };
}
